export default {
	leadInfo: 'Detail příležitosti',
	leadNotes: 'Poznámky od klienta / uživatele',
	leadNoteFieldLabel: 'Poznámky k příležitosti',
	leadDetailFeedback: 'Zpětná vazba',

	leadNotificationDate: 'Datum platnosti od',
	leadDeadlineDate: 'Datum platnosti do',
	leadSubtype: 'Podtyp příležitosti',
	finishTypeSetDate: 'Termín zadání finální zpětné vazby',
	returnLeadToMarketPlace: 'Vrátit do volného tržiště',
	leadHistory: 'Historie příležitosti',

	sidebarLeadDetailClientInfo: 'Informace o klientovi',
	sidebarLeadDetailPolicyInfo: 'Informace o PS',
	sidebarBusinessIn: 'IČO',
	sidebarPSNumber: 'Číslo PS',
	sidebarProposalNumber: 'Číslo návrhu GP',
	sidebarInsurance: 'Pojištění',
	sidebarPSStatus: 'Stav PS',
	sidebarDateNegotiation: 'Datum sjednání PS',
	sidebarDateBegining: 'Datum počátku PS',
	sidebarDateEnd: 'Datum ukončení PS',
	sidebarSecondHeader: 'INFORMACE O KLIENTOVI',
	sidebarName: 'Příjmení a jméno',
	sidebarStreet: 'Ulice',
	sidebarCity: 'Obec',
	sidebarPSC: 'PSČ',
	sidebarPhone: 'Telefon',
	sidebarEmail: 'E-mail',
	sidebarContactEmail: 'Kontaktní e-mail',
	sidebarContactPhone: 'Kontaktní telefon',
	sidebarClaimNo: 'Číslo PU',
};
